import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container container-choose-route d-flex flex-column align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RentComponent = _resolveComponent("RentComponent")!
  const _component_CustomRouteWrapperComponent = _resolveComponent("CustomRouteWrapperComponent")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_RentComponent, {
      "with-driver": this.store.state.order.withDriver
    }, null, 8, ["with-driver"]),
    _createVNode(_component_CustomRouteWrapperComponent)
  ]))
}